import React from "react";
import BookCard from "../components/Books/BookCard";
import booksData from "../data/books.json";

export default function Books() {
  const books = Array.isArray(booksData) ? booksData : [];

  const styles = {
    wrap: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "24px",
    },
    h1: {
      fontSize: "2rem",
      margin: "0 0 8px",
      color: "#0f172a",
    },
    lead: {
      color: "#334155",
      margin: "0 0 24px",
    },
    grid: {
      display: "grid",
      gap: "24px",
      gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    },
  };

  return (
    <section style={styles.wrap}>
    

      <div style={styles.grid}>
        {books.map((b) => (
          <BookCard key={b.id} book={b} />
        ))}
      </div>
    </section>
  );
}
